import "./styles/Bulkuploadviewskeleton.css";

const BulkUploadViewSkeleton = () => {
  return (
    <div className="gx-bpr-sb-sep-one-detail-sec">
      {/* Header Skeleton */}
      <div className="gx-bpr-sb-sep-one-detail-hd">
        <div className="gx-skeleton gx-skeleton-header-title" />
      </div>

      {/* Amount Card Skeleton */}
      <div className="gx-bpr-sb-sep-one-detail-a-c-sec">
        <div className="gx-bpr-sb-sep-one-detail-a-c-in-fl">
          <span className="gx-bpr-sb-sep-one-detail-amt">
            <div className="gx-skeleton gx-skeleton-text-medium" />
          </span>
          <span className="gx-bpr-pr-3">
            <div className="gx-skeleton gx-skeleton-text-large" />
          </span>
        </div>
      </div>

      {/* Transfer From Section Skeleton */}
      <div className="gx-bpr-sb-sep-one-trans-from-sec">
        <div className="gx-bpr-sb-sep-one-trans-from-fl">
          <div className="gx-skeleton gx-skeleton-section-title" />
          <div className="gx-skeleton gx-skeleton-icon" />
        </div>
        <div className="gx-bpr-sb-sep-one-trans-from-in-data-sec">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="gx-bpr-sb-sep-one-trans-from-in-d-sec-fl">
              <span className="gx-bpr-sb-sep-one-trans-from-in-d-l">
                <div className="gx-skeleton gx-skeleton-text-small" />
              </span>
              <span className="gx-bpr-sb-sep-one-trans-from-in-d-r">
                <div className="gx-skeleton gx-skeleton-text-medium" />
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Transfer To Section Skeleton */}
      <div className="gx-bpr-sb-sep-one-trans-s-sec">
        <div className="gx-bpr-sb-sep-one-trans-s-sec-fl">
          <div className="gx-skeleton gx-skeleton-section-title" />
          <div className="gx-skeleton gx-skeleton-icon" />
        </div>
        <div className="gx-bpr-sb-sep-one-trans-s-in-data-sec">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="gx-bpr-sb-sep-one-trans-s-in-d-sec-fl">
              <span className="gx-bpr-sb-sep-one-trans-s-in-d-l">
                <div className="gx-skeleton gx-skeleton-text-small" />
              </span>
              <span className="gx-bpr-sb-sep-one-trans-s-in-d-r">
                <div className="gx-skeleton gx-skeleton-text-medium" />
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Transaction Details Section Skeleton */}
      <div className="gx-bpr-sb-sep-one-trans-det-sec">
        <div className="gx-bpr-sb-sep-one-trans-det-sec-fl">
          <div className="gx-skeleton gx-skeleton-section-title" />
          <div className="gx-skeleton gx-skeleton-icon" />
        </div>
        <div className="gx-bpr-sb-sep-one-trans-det-in-data-sec">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
            <div key={i} className="gx-bpr-sb-sep-one-trans-det-in-d-sec-fl">
              <span className="gx-bpr-sb-sep-one-trans-det-in-d-l">
                <div className="gx-skeleton gx-skeleton-text-small" />
              </span>
              <span className="gx-bpr-sb-sep-one-trans-det-in-d-r">
                <div className="gx-skeleton gx-skeleton-text-medium" />
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BulkUploadViewSkeleton;
